import { render, staticRenderFns } from "./BillingLists.vue?vue&type=template&id=c1978610&scoped=true"
import script from "./BillingLists.vue?vue&type=script&lang=js"
export * from "./BillingLists.vue?vue&type=script&lang=js"
import style0 from "./BillingLists.vue?vue&type=style&index=0&id=c1978610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1978610",
  null
  
)

export default component.exports